import React, { useEffect, useState } from "react";
import "./homeProducts.css";
import axiosInstance from "../../apis/config";
import HomeProductsCard from "./homeProductsCard";
import { Link } from "react-router-dom";

const Accessories = () => {
  const [products, setProducts] = useState([]);
  const [showSpinner, setShowSpinner] = useState(true);

  useEffect(() => {
    setShowSpinner(true);
    axiosInstance
      .get("/products/random-accessories", {})
      .then((response) => {
        setProducts(response.data.data);
        setShowSpinner(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <section
      className="product-container"
      aria-labelledby="security-systems-heading"
      itemScope
      itemType="https://schema.org/ItemList"
    >
      <h2 id="security-systems-heading" className="sr-only">
        Security Alarms & Automated Systems in Nakuru, Kenya
      </h2>

      {showSpinner ? (
        <div
          className="container"
          style={{ paddingTop: "10px", paddingBottom: "10px" }}
        >
          <h3 className="title he-headers">
            Security Alarms & Automated Systems
          </h3>
          <div className="product-grid">
            {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className="card"
                aria-hidden="true"
                itemScope
                itemType="https://schema.org/Product"
              >
                <div className="card-body">
                  <h4 className="card-title placeholder-glow">
                    <span className="placeholder col-6" itemProp="name"></span>
                  </h4>
                  <p className="card-text placeholder-glow">
                    <span
                      className="placeholder col-7"
                      itemProp="description"
                    ></span>
                    <span className="placeholder col-4"></span>
                    <span className="placeholder col-4"></span>
                    <span className="placeholder col-6"></span>
                    <span className="placeholder col-8"></span>
                  </p>
                  <p className="card-text placeholder-glow">
                    <span className="placeholder col-7"></span>
                    <span
                      className="placeholder col-4"
                      itemProp="offers"
                      itemScope
                      itemType="https://schema.org/Offer"
                    >
                      <meta itemProp="priceCurrency" content="KES" />
                      <span
                        itemProp="price"
                        className="placeholder col-4"
                      ></span>
                    </span>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="container">
          <div className="product-main">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h3 className="title he-headers">
                <span itemProp="name">Security Alarms & Automated Systems</span>
              </h3>
              <span
                style={{
                  fontSize: "12px",
                  color: "gray",
                  cursor: "pointer",
                  marginTop: "5px",
                }}
              >
                <Link
                  to={`/search?page=1&query=Security+Alarms+Automated+Systems`}
                  aria-label="Browse all security alarms and automated systems in Nakuru"
                  itemProp="url"
                >
                  See All
                </Link>
              </span>
            </div>
            <div
              className="product-grid"
              itemScope
              itemType="https://schema.org/ItemList"
            >
              {products.map((product, index) => (
                <HomeProductsCard
                  key={product._id}
                  product={product}
                  itemScope
                  itemType="https://schema.org/Product"
                  itemProp="itemListElement"
                  position={index + 1}
                />
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Accessories;
